/**
 * @generated SignedSource<<cd51a5705e4b6896291bf0cba090ebde>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteTestUserButtonFragment$data = {
  readonly fullName: string;
  readonly id: string;
  readonly " $fragmentType": "DeleteTestUserButtonFragment";
};
export type DeleteTestUserButtonFragment$key = {
  readonly " $data"?: DeleteTestUserButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteTestUserButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeleteTestUserButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "42cbcd8967191e5235c25cb6055665d0";

export default node;
